import { combineReducers } from 'redux';
import loadingStateReducerFactory from '@nhl/loading-state-reducer-factory';
import actionTypes from './actionTypes';

const covidReportsLoadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_COVID_REPORTS)(actionTypes.COVID_REPORTS_RESPONSE);
const covidReportDateRangeLoadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_COVID_REPORT_DATE_RANGE)(actionTypes.COVID_REPORT_DATE_RANGE_RESPONSE);

const covidReportReducer = (state = [], action) => {
    switch (action.type) {
        case actionTypes.COVID_REPORTS_RESPONSE:
            return action.payload.response;
        default: return state;
    }
};

const covidReportDateRangeReducer = (state = '', action) => {
    switch (action.type) {
        case actionTypes.COVID_REPORT_DATE_RANGE_RESPONSE:
            return action.payload.response;
        default: return state;
    }
};

const reducer = combineReducers({
    covidReports: covidReportReducer,
    covidReportsLoadingState: covidReportsLoadingStateReducer,
    covidReportDateRange: covidReportDateRangeReducer,
    covidReportDateRangeLoadingState: covidReportDateRangeLoadingStateReducer,
});

export default reducer;